(function () {
  var scriptTag = document.currentScript || document.querySelector('script[data-variant-atc-sync]');
  if (!scriptTag) return;

  var sectionId = scriptTag.getAttribute('data-section-id');
  if (!sectionId) return;

  var productFormId = 'product-form-' + sectionId;
  var variantData = null;
  var lastSyncedURL = '';
  var updating = false;
  var buttonObserver = null;

  function getVariantData() {
    if (variantData && variantData.length) return variantData;
    try {
      var el =
        document.getElementById('VariantATCData-' + sectionId) ||
        document.querySelector('variant-radios[data-section="' + sectionId + '"] [type="application/json"]') ||
        document.querySelector('variant-selects[data-section="' + sectionId + '"] [type="application/json"]');
      if (el) variantData = JSON.parse(el.textContent);
    } catch (e) {
      variantData = null;
    }
    return variantData || [];
  }

  function getVariantFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      var id = params.get('variant');
      if (!id) return null;
      id = parseInt(id, 10);
      if (isNaN(id)) return null;
      var variants = getVariantData();
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
    } catch (e) {}
    return null;
  }

  function applyButtonState(variant) {
    if (!variant || updating) return;
    updating = true;
    try {
      var productForm = document.getElementById(productFormId);
      if (!productForm) return;

      var hiddenInput = productForm.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
        hiddenInput.disabled = !variant.available;
      }

      var addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      var addButtonText = addButton.querySelector('span');
      if (!addButtonText) return;

      if (variant.available) {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      }

      observeButton(addButton);
    } catch (e) {} finally {
      updating = false;
    }
  }

  function observeButton(button) {
    if (buttonObserver) buttonObserver.disconnect();
    try {
      buttonObserver = new MutationObserver(function () {
        if (updating) return;
        var variant = getVariantFromURL();
        if (!variant) return;
        var isDisabled = button.hasAttribute('disabled');
        if ((variant.available && isDisabled) || (!variant.available && !isDisabled)) {
          applyButtonState(variant);
        }
      });
      buttonObserver.observe(button, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
    } catch (e) {}
  }

  function syncButtonFromURL() {
    var variant = getVariantFromURL();
    if (variant) applyButtonState(variant);
  }

  function onURLChange() {
    var currentURL = window.location.href;
    if (currentURL === lastSyncedURL) return;
    lastSyncedURL = currentURL;
    syncButtonFromURL();
    setTimeout(syncButtonFromURL, 100);
    setTimeout(syncButtonFromURL, 350);
    setTimeout(syncButtonFromURL, 750);
    setTimeout(syncButtonFromURL, 1500);
  }

  try {
    var origPushState = history.pushState;
    history.pushState = function () {
      origPushState.apply(this, arguments);
      onURLChange();
    };
  } catch (e) {}

  try {
    var origReplaceState = history.replaceState;
    history.replaceState = function () {
      origReplaceState.apply(this, arguments);
      onURLChange();
    };
  } catch (e) {}

  window.addEventListener('popstate', onURLChange);

  setInterval(function () {
    var currentURL = window.location.href;
    if (currentURL !== lastSyncedURL) onURLChange();
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lastSyncedURL = '';
      onURLChange();
    });
  } else {
    onURLChange();
  }
})();
